import {DocumentExtractionBehaviour} from '../types/DocumentExtractionBehaviour';

export const AI_EXTRACTION_BEHAVIOUR: DocumentExtractionBehaviour = {
  mode: 'aiExtraction',
  isDocumentPreviewVisible: true,
  areSourceItemsReadOnly: false,
  allowZeroPrices: false,
  priceDecimalPlaces: 2,
  isArticlePrefillEnabled: true,
  isPriceRecalculationEnabled: true,
  isDocumentIdentityLocked: false,
  preservesDocumentCurrency: false,
  clearsWarehouseOnSupplierChange: false,
};
